<template>
  <div class="modal">
    <div class="modal__container">
      <div class="modal__wrap">
        <button class="modal__close" @click="modalHidden">
          ×
        </button>

        <div class="modal__header">
          <div class="h1">
            <div>{{dataValue.title}}</div>
          </div>
        </div>

        <div class="modal__body">
          <div class="modal__text">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataValue: {
      type: Object,
      title: String,
      show: Boolean
    }
  },
  methods: {
    modalHidden () {
      this.dataValue.show = false
      this.$router.push({ query: "" });
    }
  },
  beforeCreate: function() {
    document.body.className = "modal-open";
  },
  destroyed: function() {
    document.body.classList.remove("modal-open");
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  transform: translate(100%);
}

.modal {
  @extend .transition, .flex;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  top: 0;
  left: 0;
  z-index: $z-index__modal;
  color: $color__text-primary;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1);

  &__container {
    @extend .transition, .relative;
    margin: auto;
    background: #fff url("/img/layout/bg1.svg");
    padding: 20px;
    border-radius: 5px;
    width: 100%;
    min-height: 100%;
  }

  &__wrap {
    max-width: $width__container-big;
    margin: auto;
  }

  &__block {
    margin-top: 15px;
  }

  &__body {
    margin-top: 20px;
  }

  &__footer {
    margin-top: 25px;
    text-align: right;
  }

  &__close {
    @extend .absolute, .pointer;
    font-size: 60px;
    color: #000;
    padding: 0;
    right: 50px;
    top: 10px;
    background: #fff;
    border-radius: 0 5px 5px 0;

    @media (max-width: 575.98px) {
      font-size: 40px;
      padding: 0 10px;
      right: 0;
      top: 0;
    }
  }
}
</style>